import api from './api';
import {
    CouponAttributes,
    CouponResponse,
    SingleCouponResponse
} from '../types/coupon';

export const getCoupons = async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    isActive?: boolean;
}): Promise<CouponResponse> => {
    const response = await api.get('/coupons', { params });
    return response.data;
};

export const getCouponById = async (id: string): Promise<SingleCouponResponse> => {
    const response = await api.get(`/coupons/${id}`);
    return response.data;
};

export const createCoupon = async (data: Omit<CouponAttributes, 'id' | 'createdAt' | 'updatedAt'>): Promise<SingleCouponResponse> => {
    const response = await api.post('/coupons', data);
    return response.data;
};

export const updateCoupon = async (id: string, data: Partial<CouponAttributes>): Promise<SingleCouponResponse> => {
    const response = await api.put(`/coupons/${id}`, data);
    return response.data;
};

export const deleteCoupon = async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/coupons/${id}`);
    return response.data;
};

export const toggleCouponStatus = async (id: string): Promise<SingleCouponResponse> => {
    const response = await api.patch(`/coupons/${id}/toggle`);
    return response.data;
};
